import {QuestsModel,  QuestsCategoryModel} from "../Models/quests.model";
import request, { Method } from "../request";


export class QuestsService {
    async getQuests() {
        return request<QuestsModel[]>(`/quests/getQuests`, Method.GET);
    }
    async getQuestCategories(){
        return request<QuestsCategoryModel[]>(`/quests/getQuestCategories`, Method.GET);
    }

    async createQuest(quest: QuestsModel) {
        return new Promise<QuestsModel>((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;

                        quest.created_gps = JSON.stringify({
                            lat: latitude,
                            lng: longitude
                        });

                        try {
                            const response = await request<QuestsModel>(
                                `/quests/createQuest`,
                                Method.POST,
                                { data: quest }
                            );
                            resolve(response);
                        } catch (error) {
                            reject(error);
                        }
                    },
                    async () => {
                        quest.created_gps = null;
                        try {
                            const response = await request<QuestsModel>(
                                `/quests/createQuest`,
                                Method.POST,
                                { data: quest }
                            );
                            resolve(response);
                        } catch (error) {
                            reject(error);
                        }
                    }
                );
            } else {
                quest.created_gps = null;
                request<QuestsModel>(`/quests/createQuest`, Method.POST, { data: quest })
                    .then(resolve)
                    .catch(reject);
            }
        });
    }


    async finishQuest(formData: FormData) {
        return new Promise<any>((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;

                        formData.append("finished_gps", JSON.stringify({
                            lat: latitude,
                            lng: longitude,
                        }));

                        try {
                            const response = await request('/quests/finishQuest', Method.POST, {
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            });
                            resolve(response);
                        } catch (error) {
                            reject(error);
                        }
                    },
                    async () => {
                        formData.append("finished_gps", null as any);

                        try {
                            const response = await request('/quests/finishQuest', Method.POST, {
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            });
                            resolve(response);
                        } catch (error) {
                            reject(error);
                        }
                    }
                );
            } else {
                formData.append("finished_gps", null as any);

                request('/quests/finishQuest', Method.POST, {
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(resolve)
                    .catch(reject);
            }
        });
    }

}